import { FC, useCallback, useState } from 'react';
import classNames from 'classnames';
import loadable from '@loadable/component';
import { AdvertDetailType, AdvertType } from '@edikk-edikk/country-frontend';
import advertCardCss from '../assets/advert-card.module.scss';
import { AdvertCardContext, AdvertCardContextType } from '#advert/components/card/contexts';
import { Footer, Header, useClickLogicForFavoriteToggle } from '#advert/components/card';
import { AdvertBottomSheetContext, AdvertBottomSheetContextType } from '#advertBottomSheet/contexts';
import { AdvertBottomSheetWrapper } from '#advertBottomSheet/containers';

const AdvertBottomSheet = loadable(() => import('#advertBottomSheet/containers/AdvertBottomSheet'), {
  resolveComponent: ({ AdvertBottomSheet: Component }) => Component,
});

type PropsType = {
  advert: AdvertType;
  additionalClassName?: string;
  onDetailLoadedSuccess?: (data: AdvertDetailType|null) => void;
  onBottomSheetHideEnd?: () => void;
  isAllowBottomSheet?: boolean;
};

const AdvertCard: FC<PropsType> = ({
  advert,
  additionalClassName = null,
  onDetailLoadedSuccess = null,
  onBottomSheetHideEnd = null,
  isAllowBottomSheet = false,
}) => {
  const clickLogicForFavoriteToggle = useClickLogicForFavoriteToggle();
  const [isLoadedBottomSheet, setIsLoadedBottomSheet] = useState<boolean>(false);
  const [isVisibleBottomSheet, setIsVisibleBottomSheet] = useState<boolean>(false);

  const showBottomSheet = useCallback(() => {
    if (isLoadedBottomSheet) {
      setIsVisibleBottomSheet(true);
      return;
    }

    AdvertBottomSheet.load().then(() => {
      setIsLoadedBottomSheet(true);
      setIsVisibleBottomSheet(true);
    });
  }, [isLoadedBottomSheet]);

  const hideBottomSheet = useCallback(() => {
    setIsVisibleBottomSheet(false);
  }, []);

  const advertCardContextValue: AdvertCardContextType = {
    advert,
    showBottomSheet,
    clickLogicForFavoriteToggle,
    isAllowBottomSheet,
  };

  const advertBottomSheetContext: AdvertBottomSheetContextType = {
    id: advert.id,
    AdvertBottomSheet,
    isLoaded: isLoadedBottomSheet,
    isVisible: isVisibleBottomSheet,
    show: showBottomSheet,
    hide: hideBottomSheet,
    onDetailLoadedSuccess,
    onHideEnd: onBottomSheetHideEnd,
  };

  return (
    <AdvertCardContext value={advertCardContextValue}>
      <div
        className={classNames(advertCardCss.advertCard, additionalClassName)}
        data-id={advert.id}
      >
        <Header />
        <Footer />
      </div>
      <AdvertBottomSheetContext value={advertBottomSheetContext}>
        <AdvertBottomSheetWrapper />
      </AdvertBottomSheetContext>
    </AdvertCardContext>
  );
};

export { AdvertCard };
